<div class="nav-layout d-flex overflow-hidden h-100">
  <app-navigation></app-navigation>
  <main class="main is-visible bg-dark">
    <div class="bg-white h-100">
      <div class="d-flex flex-column h-100 position-relative">
        <app-header></app-header>
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
